import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IBasicUserType } from '../..';
import { IStyledContentProps } from './DropDownBox.types';

export const StyledArrow = styled.span`
  display: flex;
  margin-left: ${rem('8px')};

  svg {
    width: ${rem('13px')};
    height: auto;
  }
`;

export const StyledButton = styled.button<IBasicUserType>`
  display: inline-flex;
  align-items: center;
  padding: 0;
  color: ${({ theme, user }) => user && theme.colors[user].main};
  font-size: ${rem('16px')};
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  &[aria-expanded='true'] {
    ${StyledArrow} {
      transform: rotate(180deg);
    }
  }

  &:focus {
    outline: none; //TODO add proper focus style
  }
`;

export const StyledButtonColon = styled.span`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
  }
`;

export const StyledButtonCurrentText = styled.span`
  display: none;
  margin-left: ${rem('6px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
  }
`;

export const StyledButtonText = styled.span`
  font-weight: 700;
  text-decoration: underline;
`;

export const StyledContent = styled.div<IStyledContentProps>`
  position: absolute;
  top: ${rem('32px')};
  right: 0;
  z-index: 3;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  padding: ${rem('16px')};
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${rem('16px')};
  box-shadow: 0 0 ${rem('8px')} 0
    ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
`;

export const StyledNav = styled.nav`
  position: relative;
  display: inline-flex;
`;
